export const DtiWaitPropsBase = {
  dtiRatioAssessment: 'low',
  beginningLine: 'If you wait 3 more months to get rid of debt, you’re estimated to pay',
  endingLine: 'in total debt.',
  totalDebt: 2300,
  moreEachMonth: 57,
  moreMonthsToBeDebtFree: 4,
  linkHref: '/',
  linkText: 'Explore debt solutions',
  showWaitTime: false,
  onClick: () => {},
}
